<template>
    <div class="body_main">
        <div class="body_bd">
            <!-- 搜索-->
            <el-form class="search_con" :model="queryParams" ref="queryForm" :inline="true" label-width="68px">
                <el-form-item label="日期">
                    <el-date-picker
                        v-model="queryParams.schDate"
                        value-format="YYYY-MM-DD"
                        type="date" placeholder="选择日期"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="Search" @click="getCallNumberListInfo()">搜索</el-button>
                    <el-button icon="Refresh" @click="resetQuery">重置</el-button>
                </el-form-item>
            </el-form>

            <div class="call_page_statistics">
                <div v-for="item in callPageStats" :key="item.key"
                     :class="['call_page_stat', 'call_page_stat_' + item.key, queryParams.reStatus === item.status ? 'call_page_stat_active' : '']"
                     @click="chooseStatusCard(item.status)">
                    <div class="call_page_stat_count">{{ item.count }}</div>
                    <div class="call_page_stat_label">{{ item.label }}</div>
                </div>
            </div>

            <!-- 表格-->
            <div class="table_bd">
                <el-table
                    ref="multipleTable"
                    v-loading="tableLoading"
                    :data="tableData"
                    :max-height="tableHeight"
                    style="width: 100%">
                    <template #empty>
                        <el-empty :image-size="120"></el-empty>
                    </template>
                    <el-table-column type="index" label="序号" width="50"> </el-table-column>
                    <el-table-column
                        prop="reSerialNo"
                        label="预约单号">
                    </el-table-column>
                    <el-table-column
                        label="预约人">
                        <template #default="scope">
                            <div class="base_con">
                                <el-image class="elImage" :src="scope.row.avatar"></el-image>
                                <div class="base_info">
                                    <span style="font-size: 16px; font-weight: 600; line-height: 24px">{{ scope.row.cardPatientName }} </span>
                                    <span style="font-size: 14px; color:#aaa; line-height: 24px">{{ scope.row.sexText }}  {{ scope.row.age }}岁</span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="预约人手机号">
                        <template #default="scope">
                            <span>{{ scope.row.cardPatientPhone === null ? '---' : scope.row.cardPatientPhone }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="预约人身份证">
                        <template #default="scope">
                            <span>{{ scope.row.cardIdentity === null ? '---' : scope.row.cardIdentity }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="预约时间"
                        width="260">
                        <template #default="scope">
                            <span style="font-size: 14px; font-weight: 600">{{ scope.row.reTime === null ? '---' : scope.row.reTime }} {{scope.row.reTimeTypeText}}{{ (scope.row.queueSeq || scope.row.reNo) ? (scope.row.queueSeq || scope.row.reNo) + '号' : '' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="排队状态"
                        width="120">
                        <template #default="scope">
                            <el-tag
                                :type="scope.row.reStatus === '5' ? 'primary' : scope.row.reStatus === '6' ? 'success' : scope.row.reStatus === '7' ? 'danger' : scope.row.reStatus === '8' ? 'warning' : ''"
                                disable-transitions>{{ scope.row.reStatusText }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="医生">
                        <template #default="scope">
                            <span>{{ scope.row.doctorName === null ? '---' : scope.row.doctorName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="诊室">
                        <template #default="scope">
                            <span>{{ scope.row.odName === null ? '---' : scope.row.odName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="createTime"
                        label="报到时间">
                    </el-table-column>
                    <el-table-column
                        fixed="right"
                        label="操作"
                        width="200">
                        <template #default="scope">
                            <el-button type="warning" size="small" @click="handleSign(scope.row)" v-if="scope.row.reStatus === '8'">签到</el-button>
                            <el-button type="primary" size="small" v-on:click="calling(scope.row)"
                                       v-if="scope.row.reStatus === '5' || scope.row.reStatus === '7'">叫号</el-button>
                            <el-button type="success" size="small" v-on:click="callToOrder(scope.row)"
                                       v-if="scope.row.reStatus === '5' || scope.row.reStatus === '7'">接诊</el-button>
                            <el-text class="mx-1" type="success" v-if="scope.row.reStatus === '6'">就诊中...</el-text>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- 分页-->
            <div class="table_pagination">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-size="pageNums"
                    layout="prev, pager, next, total, sizes"
                    :total="totalCount">
                </el-pagination>
            </div>

        </div>
    </div>

</template>

<script>
import consultationcall from "@/assets/scripts/consultationcall/index";

export default consultationcall;
</script>

<style scoped lang="scss">
    @import "@/assets/styles/admin.scss";

    .call_page_statistics{
        display: flex;
        width: 100%;
        gap: 12px;
        margin-bottom: 16px;
    }

    .call_page_stat{
        flex: 1;
        min-width: 0;
        height: 82px;
        padding: 10px 8px;
        box-sizing: border-box;
        text-align: center;
        border: 1px solid transparent;
        border-radius: 8px;
        cursor: pointer;
        transition: all .2s ease;
    }

    .call_page_stat_count{
        line-height: 34px;
        font-size: 24px;
        font-weight: bold;
    }

    .call_page_stat_label{
        line-height: 22px;
        font-size: 14px;
        font-weight: 600;
    }

    .call_page_stat_all{
        color: #3478f6;
        background: #edf4ff;
        border-color: #d5e5ff;
    }

    .call_page_stat_wait{
        color: #e67e22;
        background: #fff4e8;
        border-color: #ffe1bf;
    }

    .call_page_stat_sign{
        color: #d99a19;
        background: #fff8e8;
        border-color: #f6e0a8;
    }

    .call_page_stat_done{
        color: #2f9e63;
        background: #ecf9f1;
        border-color: #ccefdc;
    }

    .call_page_stat_jump{
        color: #7c5aa6;
        background: #f5effb;
        border-color: #e5d8f4;
    }

    .call_page_stat_active{
        color: #ffffff;
        font-weight: bold;
        box-shadow: 0 3px 8px rgba(60, 75, 95, .18);
    }

    .call_page_stat_all.call_page_stat_active{
        background: #3478f6;
        border-color: #3478f6;
    }

    .call_page_stat_wait.call_page_stat_active{
        background: #e67e22;
        border-color: #e67e22;
    }

    .call_page_stat_sign.call_page_stat_active{
        background: #d99a19;
        border-color: #d99a19;
    }

    .call_page_stat_done.call_page_stat_active{
        background: #2f9e63;
        border-color: #2f9e63;
    }

    .call_page_stat_jump.call_page_stat_active{
        background: #7c5aa6;
        border-color: #7c5aa6;
    }
</style>
